/*
 * @Description: 数字存证管理
 * @Date: 2024-03-26 11:18:13
 */
import { route } from './src/router';

const name = 'digtalStorage';

export { name, route };
